import guest from '@middlewares/Guest';

export default [
  {
    url: '/',
    name: 'auth',
    page: 'auth/Index',
    meta: {
      layout: 'Auth',
      middleware: guest,
    },
    group: [
      {
        url: '/login',
        page: 'auth/Login',
        name: 'login',
      },
      {
        url: '/forgot-password',
        page: 'auth/ForgotPassword',
        name: 'forgot_password',
      },
      {
        url: '/password/reset/:token?',
        page: 'auth/ResetPassword',
        name: 'reset_password',
      },
      {
        url: 'email/confirm',
        page: 'auth/Confirm',
        name: 'email-confirmation',
      },
    ],
  },
];
